export const OPPORTUNITIES_ACTIONS = {
    SET_OPPORTUNITIES: "SET_OPPORTUNITIES",
    SET_IS_LOADING: "SET_IS_LOADING",
}